export const formFields = [
  {
    section: "Section 1",
    name: "aosAccumOvrdSchedule",
    label: "Schedule",
    fieldLabel: "AOS Accum Ovrd Schedule",
    type: "text",
    options: {
      maxLength: {
        value: 15,
        message: "Cannot exceed more than 15 characters",
      },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [5, 1],
  },
  {
    section: "Section 1",
    name: "aosAccumOvrdScdeDesc",
    label: "Description",
    fieldLabel: "AOS Accum Ovrd Scde Desc",
    type: "text",
    options: {
      maxLength: {
        value: 25,
        message: "Cannot exceed more than 25 characters",
      },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [6, 1],
  },
  {
    section: "Section 1",
    name: "aosAccumOvrdScdeType",
    label: "Type",
    fieldLabel: "AOS Accum Ovrd Scde Type",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [7, 1],
  },
  {
    section: "Section 1",
    name: "aocSeqNbr",
    label: "Sequence",
    fieldLabel: "AOC Seq Nbr",
    type: "number",
    options: {
      required: { value: true, message: "Value required" },
      min: { value: 0, message: "Minimum value is 0" },
      max: { value: 999, message: "Maximum value is 999" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [9, 1],
  },
  {
    section: "Section 2",
    name: "aocCustomerLocation",
    label: "Customer Location Code",
    fieldLabel: "PSC Customer Location",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "Value required" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 1],
  },
  {
    section: "Section 2",
    name: "aocPatientResidence",
    label: "Patient Residence Code",
    fieldLabel: "TC3 Patient Residence",
    type: "dropdown",
    dropdownCondition: "Plan Edit plus 'XX'",
    options: { required: { value: true, message: "Value required" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 1],
  },
  {
    section: "Section 2",
    name: "aocCompoundCode",
    label: "Compound Code",
    fieldLabel: "PSC Compound",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "Value required" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [12, 1],
  },
  {
    section: "Section 2",
    name: "aocDrugStatus",
    label: "Drug Status Code",
    fieldLabel: "Drug Status w/option *",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "Value required" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [13, 1],
  },
  {
    section: "Section 2",
    name: "aocDaysSupplyFrom",
    label: "Days Supply Range",
    fieldLabel: "AOC Days Supply From",
    type: "number",
    options: {
      optional: true,
      min: { value: 0, message: "Minimum value is 0" },
      max: { value: 999, message: "Maximum value is 999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 1],
  },
  {
    section: "Section 2",
    name: "aocDaysSupplyTo",
    label: "to",
    fieldLabel: "AOC Days Supply To",
    type: "number",
    options: {
      optional: true,
      min: { value: 0, message: "Minimum value is 0" },
      max: { value: 999, message: "Maximum value is 999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 2],
  },
  {
    section: "Section 2",
    name: "aocMaintenance",
    label: "Maintenance Code",
    fieldLabel: "AOC Maintenance",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "Value required" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [15, 1],
  },
  {
    section: "Section 2",
    name: "aocDeaClassCode",
    label: "DEA Class Code",
    fieldLabel: "PSC DEA Class",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { optional: true },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 1],
  },
  {
    section: "Section 2",
    name: "aocDeaClassList",
    label: "DEA Class List",
    fieldLabel: "AOC DEA Class List",
    type: "lookup", //RCDCL005
    externalProgram: { default: "RCDCL005" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "aocDeaClassList",
            target: "list",
            legacy: "dclDeaClassList",
          },
        ],
      },
    },
    options: {
      optional: true,
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 2],
  },
  {
    section: "Section 2",
    name: "aocPharDispenserType",
    label: "Phar Dispenser Type Code",
    fieldLabel: "AOC Phar Dispenser Type",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { optional: true },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 1],
  },
  {
    section: "Section 2",
    name: "aocTier",
    label: "Tier Code",
    fieldLabel: "AOC Tier",
    type: "text",
    options: {
      required: { value: true, message: "Value required" },
      maxLength: { value: 2, message: "Cannot exceed more than 2 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 1],
  },
  {
    section: "Section 2",
    name: "aocOtc",
    label: "OTC Code",
    fieldLabel: "AOC OTC",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { required: { value: true, message: "Value required" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [19, 1],
  },
  {
    section: "Section 2",
    name: "aocThirdPartyException",
    label: "3rd Party Exception Code",
    fieldLabel: "AOC Third Party Exception",
    type: "lookup",
    externalProgram: {
      default: "RC3EX900",
    },
    viewMode: "text",
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          { source: "aocThirdPartyException", target: "thirdPartyException" },
        ],
      },
    },

    options: {
      required: { value: true, message: "Value required" },
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [20, 1],
  },
  {
    section: "Section 2",
    name: "aocRouteOfAdmin",
    label: "Route of Admin Code",
    fieldLabel: "AOC Route of Admin",
    type: "lookup",
    externalProgram: {
      default: "RCRAD900",
    },
    viewMode: "text",
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          { source: "aocRouteOfAdmin", target: "routeOfAdministration" },
        ],
      },
    },
    options: {
      optional: true,
      maxLength: { value: 2, message: "Cannot exceed more than 2 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [21, 1],
  },
  {
    section: "Section 2",
    name: "aocRouteOfAdminList",
    label: "Route of Admin List",
    fieldLabel: "AOC Route of Admin List",
    type: "lookup",
    externalProgram: {
      default: "RCRAL004",
    },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          { source: "aocRouteOfAdminList", target: "list", legacy: "ralList" },
        ],
      },
    },
    options: {
      optional: true,
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [21, 2],
  },
  {
    section: "Section 2",
    name: "aocDosageForm",
    label: "Dosage Form Code",
    fieldLabel: "AOC Dosage Form",
    type: "lookup",
    externalProgram: { default: "RCDF1001" },
    viewMode: "text",
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [{ source: "aocDosageForm", target: "code" }],
      },
    },
    options: {
      optional: true,
      maxLength: { value: 4, message: "Cannot exceed more than 4 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [22, 1],
  },
  {
    section: "Section 2",
    name: "aocDosageFormList",
    label: "Dosage Form List",
    fieldLabel: "AOC Dosage Form List",
    type: "lookup", //RCDFL005
    externalProgram: { default: "RCDFL005" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "aocDosageFormList",
            target: "list",
            legacy: "dflDosageFormList",
          },
        ],
      },
    },
    options: {
      optional: true,
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [22, 2],
  },
  {
    section: "Section 2",
    name: "aocPackagingCode",
    label: "Packaging Code",
    fieldLabel: "PSC Packaging",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { optional: true },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [23, 1],
  },
  {
    section: "Section 2",
    name: "aocPackagingList",
    label: "Packaging List",
    fieldLabel: "AOC Packaging List",
    type: "lookup", //RCPKL005
    externalProgram: { default: "RCPKL005" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [{ source: "aocPackagingList", target: "list" }],
      },
    },
    options: {
      optional: true,
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [23, 2],
  },

  {
    section: "Section 2",
    name: "aocNdcList",
    label: "NDC List",
    fieldLabel: "AOC NDC List",
    type: "lookup", //RCND1004
    externalProgram: { default: "RCND1004" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          { source: "aocNdcList", target: "level", legacy: "nd1NdcListName" },
        ],
      },
    },
    options: {
      optional: true,
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [24, 1],
  },

  {
    section: "Section 2",
    name: "aocGpiMscList",
    label: "GPI MSC List",
    fieldLabel: "AOC GPI MSC List",
    type: "lookup", //RCGP3004
    externalProgram: { default: "RCGP3004" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "aocGpiMscList",
            target: "level",
            legacy: "gp3GpiMscListId",
          },
        ],
      },
    },
    options: {
      optional: true,
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [25, 1],
  },

  {
    section: "Section 3",
    name: "aocScheduleOverride",
    label: "Schedule Override",
    fieldLabel: "AOC Schedule Override",
    type: "lookup",
    externalProgram: {
      O: "RCOPC005",
      T: "RCTSC003",
      E: "RCTSC003",
      D: "RCDSC005",
      B: "RCBSC005",
      L: "RCBSC005",
    },
    params: {
      lookupType: "conditional",
      viewType: "conditional",
      dataKey: "aosAccumOvrdScdeType",
      fieldMapping: {
        B: [{ source: "aocScheduleOverride", target: "bscScheduleName" }],
        O: [{ source: "aocScheduleOverride", target: "opcScheduleName" }],
        T: [{ source: "aocScheduleOverride", target: "tscScheduleName" }],
        E: [{ source: "aocScheduleOverride", target: "tscScheduleName" }],
        D: [{ source: "aocScheduleOverride", target: "dscScheduleName" }],
        L: [{ source: "aocScheduleOverride", target: "dscScheduleName" }],
      },
    },

    options: { optional: true },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [26, 1],
  },
  {
    section: "HIM(Header)",
    name: "aocCsrLevel",
    label: "Federal CSR Level",
    fieldLabel: "AOC Federal CSR Level",
    type: "lookup", //RCFCH004
    externalProgram: { default: "RCFCH004" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "aocCsrLevel",
            target: "level",
            legacy: "level",
            paramDataKey: "searchCriteria",
          },
        ],
      },
    },
    options: {
      optional: true,
      maxLength: { value: 2, message: "Cannot exceed more than 2 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [32, 1],
    displayConditions: [
      {
        dependentField: "aosAccumOvrdScdeType",
        dependentFieldValues: ["D", "O"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: false,
      },
    ],
  },

  {
    section: "HIM(Header)",
    name: "aocAccumulationCode",
    label: "Accumulation Code",
    fieldLabel: "AOC Accumulation Code",
    type: "lookup", //RCFCH004
    externalProgram: { default: "RCACM001" },
    params: {
      lookupType: "local",
      viewType: "local",
      fieldMapping: {
        default: [
          {
            source: "aocAccumulationCode",
            target: "acmAccumulationCode",
            legacy: "acmAccumulationCode",
            paramDataKey: "acmAccumulationCode",
          },
        ],
      },
    },
    options: {
      optional: true,
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [33, 1],
    displayConditions: [
      {
        dependentField: "aosAccumOvrdScdeType",
        dependentFieldValues: ["D", "O"],
        fieldNature: "Non-Display",
        shouldFieldValuesIncluded: false,
      },
    ],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [34, 1],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [34, 2],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [34, 3],
  },
];
